function _useIsPostPaymentVerificationSession() {
  const postPaymentVerificationRouteQuery = useRouteQuery(
    "postPaymentVerification",
  );

  const isPostPaymentVerificationSession = ref(
    postPaymentVerificationRouteQuery.value === "true",
  );

  // Clear the query after reading it
  postPaymentVerificationRouteQuery.value = undefined;

  return { isPostPaymentVerificationSession };
}

/**
 * Composable that returns whether the current session is a post-payment verification session.
 * Keeps a shared state in memory and clears the route query after reading it.
 */
export default createSharedComposable(_useIsPostPaymentVerificationSession);
